import { Component, Inject, OnInit } from "@angular/core";
import { ADFS, authConfig, environment } from "../../../environments/environment";
import {
  OAuthModule,
  OAuthService,
  AuthConfig,
  JwksValidationHandler,
} from "angular-oauth2-oidc";
import { AuthenService } from "../../services/authen.service";
import { first } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { UserLogin, User } from "../../model/user.model";
import swal from "sweetalert2";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ModalService } from "../../services/modal.service";
import { BroadcastService, MSAL_CONFIG_ANGULAR, MsalAngularConfiguration, MsalService } from "@azure/msal-angular";

declare var $: any;
import $ from "jquery";

import { HttpParams } from "@angular/common/http";
import { AuthenticationParameters } from "msal";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  accesstoken: any;
  Expiration: any;
  tokentype: any;
  ClaimDatas: any;
  message: any;
  thecode: any;
  Email: any;
  ShowLogInDev: boolean;
  currenUser: User;
  returnUrl: any;
  IPAddress: any;
  resultToken:any;
  loggedIn = false;

  constructor(@Inject(MSAL_CONFIG_ANGULAR) private angularConfig:MsalAngularConfiguration,
    private msalService:MsalService,
    private broadCastService:BroadcastService,
    private _route: ActivatedRoute,
    private oauthService: OAuthService,
    private authenService: AuthenService,
    private msg: ModalService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.configure();

    this.ShowLogInDev = environment.ShowLogInDev;
    if (!this.IPAddress) {
      this.authenService.getIpAddress().subscribe((x) => {
        this.IPAddress = x.ip;
      });
    }

    this.currenUser = JSON.parse(localStorage.getItem("currentUser"));
    if (this.currenUser) {
      this.passLogin();
    }
  }

  //Configure oauth2 and PKE implicit flow
  async configure() {
    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  ngOnInit(): void {
    this.broadCastService.subscribe('msal:loginSuccess', () => {
      this.loggedIn = !!this.msalService.getAccount();
    });

    this.msalService.handleRedirectCallback((authError, response) => {
      if (authError) {
        console.error('Redirect Error: ', authError.errorMessage);
        return;
      }
      console.log('Redirect Success: ', response);
    });
    
    // Post();
    //this.SingnIN( 'sasitorn.krad@gmail.com');

    this._route.fragment.subscribe((fragment) => {
      const param = new HttpParams({ fromString: fragment });
      if (param.get("id_token")) {
        this.spinnerService.show();
        if (this.IPAddress) {
          this.SingnIN(this.Email, param.get("id_token"));
        } else {
          this.authenService.getIpAddress().subscribe((x) => {
            this.IPAddress = x.ip;
            this.SingnIN(this.Email, param.get("id_token"));
          });
        }
      }
    });

    this.returnUrl =
      this._route.snapshot.queryParams["returnUrl"] ||
      localStorage.getItem("currentUser") ||
      "/";
    window.localStorage.setItem("returnUrl", JSON.stringify(this.returnUrl));
  }

  SingnIN(email: string, access_token: string) {
    let a: UserLogin = new UserLogin();
    a.Email = email;
    a.IPAddress = this.IPAddress;
    //a.Code = code;
    if (email) {
      this.authenService.login(a).subscribe(
        (s) => {
          this.spinnerService.hide();
          if (s.Success) {
            this.currenUser = s.Data;
            window.localStorage.setItem(
              "currentUser",
              JSON.stringify(this.currenUser)
            );
            this.passLogin();
          } else {
            swal({
              title: "เกิดข้อผิดพลาด!",
              // text: msgError,
              html: s.Msg,
              type: "error",
              confirmButtonText: "ปิด",
              allowOutsideClick: true,
            }).then((c) => {
              this.authenService.logout();
            });
          }
        },
        (err) => {
          this.spinnerService.hide();
          return swal({
            title: "เกิดข้อผิดพลาด!",
            // text: msgError,
            html: err.message,
            type: "error",
            confirmButtonText: "ปิด",
            allowOutsideClick: true,
          }).then((c) => {});
        }
      );
    } else {
      a.token = access_token;
      this.authenService.login(a).subscribe((s) => {
        this.spinnerService.hide();
        if (s.Success) {
          this.currenUser = s.Data;
          window.localStorage.setItem(
            "currentUser",
            JSON.stringify(this.currenUser)
          );
          this.passLogin();
        } else {
          swal({
            title: "เกิดข้อผิดพลาด!",
            html: s.Msg,
            type: "error",
            confirmButtonText: "ปิด",
            allowOutsideClick: true,
          }).then((c) => {
            this.authenService.logout();
          });
        }
      });

      // this.authenService.GetToken(code).subscribe(
      //   (s) => {
      //     // console.log(s);
      //     // debugger;
      //     a.token = s.access_token;
      //     this.authenService.login(a).subscribe((s) => {
      //       this.spinnerService.hide();
      //       if (s.Success) {
      //         this.currenUser = s.Data;
      //         window.localStorage.setItem(
      //           "currentUser",
      //           JSON.stringify(this.currenUser)
      //         );
      //         this.passLogin();
      //       } else {
      //         //debug
      //         //let v :any =s;
      //         // if(v.TokenInvalid){
      //         //   this.authenService.GetToken(code).subscribe(s=>{
      //         // console.log(s);
      //         //     debugger;
      //         //   });
      //         // }
      //         swal({
      //           title: "เกิดข้อผิดพลาด!",
      //           // text: msgError,
      //           html: s.Msg,
      //           type: "error",
      //           confirmButtonText: "ปิด",
      //           allowOutsideClick: true,
      //         }).then((c) => {
      //           this.authenService.logout();
      //         });
      //       }
      //     });
      //   },
      //   (error) => {
      //     this.spinnerService.hide();
      //     swal({
      //       title: "เกิดข้อผิดพลาด!",
      //       // text: msgError,
      //       html: "token Invalid",
      //       type: "error",
      //       confirmButtonText: "ปิด",
      //       allowOutsideClick: true,
      //     }).then((s) => {
      //       this.authenService.logout();
      //     });
      //   }
      // );
    }
  }

  passLogin() {
    this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";
    window.localStorage.removeItem("returnUrl");
    window.location = this.returnUrl;
  }

  LoginForTest() {
    swal({
      title: "Enter your Email",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Sign In",
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        this.spinnerService.show();
        this.SingnIN(login, null);
      },
      allowOutsideClick: () => !swal.isLoading(),
    }).then((result) => {
      if (result.value) {
        // swal({
        //   title: `${result.value.login}'s avatar`,
        //   imageUrl: result.value.avatar_url
        // })
      }
    });
  }

  public Login() {
    // cementhai\epuradmin
    // Oleo2019
    //this.oauthService.initLoginFlow();
    if(this.angularConfig.consentScopes){
    this.msalService.loginPopup({...this.angularConfig} as AuthenticationParameters)
      .then((result)=>{
        console.log(result);
        this.resultToken=result;
        this.SingnIN(null, this.resultToken.idToken.rawIdToken);
      },(err)=>{
        console.log(err);
      }
      );
    }
  }
}
